//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import HotArea from "views/hotArea"
    export default{
      props:['hasMatch','regionName','controlHotArea'],
      data(){
        return{
          showHotArea:false
        }
      },
      watch: {
        controlHotArea(curVal, oldVal){
          this.showHotArea =false;
        }
      },
      mounted(){
        this.screenScala = document.body.clientWidth/375;
        this.containerHeight = this.resizePx(this.containerHeight);
        this.infoMarginTop =this.resizePx(this.infoMarginTop);
        this.titleMargintTop = this.resizePx(this.titleMargintTop);
        this.titleMarginLeftRight = this.resizePx(this.titleMarginLeftRight);
      },
      methods:{
        resizePx:function(px){
          return px * this.screenScala + 'px';
        },
        changeRegion:function (regionCode, regionName) {
          this.$emit('changeRegion', regionCode, regionName);
        }
      },
      components:{HotArea}

    }





// WEBPACK FOOTER //
// ./src/components/publicindex/head.vue